export default {
	Welcome: 'Xin chào',
	SystemAutoInvoice: 'Hệ thống tự động tra cứu và tải hóa đơn điện tử đã sẵn sàng cùng bạn<br>hoàn thành công việc',
	StartNow: 'Bắt đầu ngay',
	WhoAreYou: 'Bạn là ai',
	SelectedSubType: 'Lựa chọn loại hình hoạt động của bạn để chúng tôi<br>đưa ra gợi ý phù hợp nhất',
	Enterprise: 'Doanh nghiệp',
	ServiceAccountCompany: 'Công ty kế toán dịch vụ',
	ServiceAccountIndividual: 'Cá nhân làm kế toán dịch vụ',
	Next: 'Tiếp tục',
	Information: 'Thông tin của bạn',
	DescriptionAuto:
		'Khi hóa đơn gửi đến email này, inbot sẽ tự động trích xuất hóa đơn, kiểm tra và nhập liệu vào phần mềm kế toán.',
	InformationCode: 'Số CMND/CCCD/Hộ chiếu',
	FullName: 'Họ tên',
	Phone: 'Số điện thoại',
	Email: 'Email',
	TaxCode: 'Mã số thuế',
	CompanyName: 'Tên công ty',
	Contact: 'Người liên hệ',
	StartedTitle: 'Khởi tạo email nhận hóa đơn',
	StartedSubTitle:
		"Vui lòng khai báo thông tin <span class='font-bold'>chính xác theo giấy phép kinh doanh.</span> Hệ thống sẽ sử dụng thông tin này để tra cứu tính pháp lý của hóa đơn.",
	StartedGuideTitle: 'Xử lý hóa đơn hoàn toàn tự động',
	StartedGuideSubTitle:
		'Tự động tra cứu, phân tích và kiểm tra thông tin hóa đơn. Kết nối đồng bộ trực tiếp với phần mềm kế toán chỉ với 3 bước.',
	TitlePermission: 'Bạn chưa được phân quyền',
	//Bổ sung 2/12
	SubTitlePermission: 'Vui lòng liên hệ quản trị để được phân quyền truy cập MISA meInvoice - Xử lý hóa đơn',
	ActiveToUse: 'Kích hoạt sử dụng',
	TitleMeInvoice: 'MISA meInvoice - Xử lý hóa đơn',
	LicenseCode: 'Mã giấy phép sử dụng',
	FillActiveCode: 'Nhập mã kích hoạt mua tại MISA Store',
	TotalInvoiceHandle: 'Số lượng hóa đơn được xử lý tối đa:',
	UnitUse: 'Đơn vị sử dụng',
	UnitActiveUse: 'Đơn vị kích hoạt sử dụng',
	User: 'Người sử dụng',
	ActiveSuccess: 'Kích hoạt thành công',
	InvoiceCapacitySupplier: {
		FirstText: 'Tài nguyên được cấp cho mã số thuế',
		SecondText: 'với số lượng',
		ThirdText: 'hóa đơn.'
	},
	LoginNow: 'Đăng nhập ngay',
	CheckKeyStatus: {
		KeyNotOfInbot: 'Mã kích hoạt không phải sản phẩm Inbot',
		KeyInvalid: 'Mã kích hoạt không hợp lệ',
		KeyActived: 'Mã đã được kích hoạt'
	},
	TaxCodeWasActived:
		'Mã số thuế đã được kích hoạt. Vui lòng đăng nhập chương trình vào quản lý tài nguyên để kích hoạt lại!',
	TaxCodeHaveInbot:
		'Mã số thuế này đã có tài khoản MISA Meinvoice và đã kích hoạt tài khoản Inbot. Vui lòng đăng nhập Meinvoice để sử dụng dịch vụ!',
	ErrorMessageRegister: {
		InValidParameter: 'Tham số không hợp lệ',
		NotFound: 'Không tìm thấy tài khoản MisaId',
		EmailOrPhoneNumberExists: 'Đã tồn tại người dùng với thông tin email, số điện thoại của tài khoản MisaId này!',
		TaxCodeNotFound: 'Mã số thuế không tồn tại!',
		Error: 'Có lỗi xảy ra đăng ký tài khoản.'
	},
	ChangeAccount: 'Đổi tài khoản',
	Active: 'Kích hoạt',
	ActiveNow: 'Kích hoạt ngay',
	TaxCodeIsWorking: 'Mã số thuế đang làm việc khác với mã số thuế mua trên MISA Store. Vui lòng kiểm tra lại.',
	Promotion: {
		TakeSale: 'Nhận khuyến mại',
		FirstName: 'Họ và đệm',
		LastName: 'Tên'
	},
	TakeCode: 'Nhận mã',
	CreateEmailToTakeAndSend: 'Tạo email nhận và gửi hóa đơn đến',
	SystemAutoDownloadAndCheck: 'Hệ thống tự động tải và kiểm tra HĐĐT',
	Synch: 'Đồng bộ vào phần mềm kế toán',
	ViewGuide: 'Xem hướng dẫn',
	ChatWithEmployee : 'Chat với nhân viên hỗ trợ trực tuyến tại đây',
	GuideLiveChat : 'Di chuyển vị trí biểu tượng chat bằng cách bấm, giữ và di chuyển chuột',
	New : 'Mới',
	ChatEmployeeForSupport : 'Chat với nhân viên tư vấn khi bạn cần hỗ trợ',
	ViewRemind : 'Xem thông báo nhắc nhở',
	Click : 'Bấm vào',
	HideSymbol : 'để ẩn các biểu tượng',
	ClickAndMouse : 'Bấm và giữ chuột để di chuyển vị trí',
	RolePermissionMISAMeInvoice : 'Bạn chưa được phân quyền làm việc trên MISA meInvoice - Xử lý hóa đơn. Vui lòng liên hệ Quản trị để được cấp quyền.',
	HelpDesc: "Anh/chị tự đặt tên cho phần đầu của email, ví dụ: hoadoncongty, đuôi mail tự động mặc định là @meinvoice.vn"
};
